import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.jsx'
import 'lenis/dist/lenis.css'
// Fonturi self-hosted (Vite emite woff2 de pe domeniul nostru → zero terți, GDPR-clean).
// Fraunces variable „opsz" = axele opsz + wght (look-ul display vine din opsz 144). Mai
// ușor cu ~45% decât „full" (fără axele SOFT/wonk). Subseturile (latin, latin-ext pentru
// ă/ș/ț, …) se descarcă după unicode-range.
import '@fontsource-variable/fraunces/opsz.css'
import '@fontsource-variable/fraunces/opsz-italic.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'
import '@fontsource/ibm-plex-mono/600.css'
import './index.css'

// Notă: folosim createRoot (NU hydrateRoot) chiar dacă #root are HTML prerendat. Animațiile
// framer (opacity), tema dinamică (scroll) și RevealLines produc nepotriviri de hidratare →
// hydrateRoot ar cădea oricum în client-render complet, dar cu consola plină de erori.
// createRoot dă un client-render curat; HTML-ul prerendat tot servește crawlerele și
// îmbunătățește LCP (conținut pictat din HTML static înainte ca JS-ul să preia).
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
)
